import { render, staticRenderFns } from "./logo-tertiary.vue?vue&type=template&id=313f5afb&scoped=true&"
import script from "./logo-tertiary.vue?vue&type=script&lang=js&"
export * from "./logo-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313f5afb",
  null
  
)

export default component.exports